import graphic from './graphic';
import util from './_utils';

let selectedLang;

function init() {
	selectedLang = util.getURLparam('lang') != '' ? (util.getURLparam('lang') == 'en-EN' ? 'en-US' : util.getURLparam('lang')) : 'en-US';

	d3.select(`.button--${selectedLang}`).classed('is-active', true);
	d3.selectAll('.lang').style('display', 'none');
	d3.selectAll(`.lang--${selectedLang}`).style('display', 'block');

	d3.selectAll(`.change-language.lang--${selectedLang}`).classed('is-visible', true)
}

function translateViz(chapter, accessor) {
	const translations = graphic.getVizTranslations(),
		tr = translations.filter(d => d.chapter == chapter).find(d => d.accessor == accessor);

	return tr[selectedLang]
}

function getCurrentLang() {
	selectedLang = util.getURLparam('lang') != '' ? (util.getURLparam('lang') == 'en-EN' ? 'en-US' : util.getURLparam('lang')) : 'en-US';

	return selectedLang;
}

export default {
	init,
	translateViz,
	getCurrentLang
}